<template>
  <div>
    <h2>Koppel opdracht aan tekenaar</h2>
    <input type="text" v-model="searchInput_tekenaarName" placeholder="Zoek een tekenaar" />
    <div :class="{ selected: tekenaar.uid === selectedUserForKoppeling_byId }" @click="setSelectedUserForKoppeling_byId(tekenaar.uid)" v-for="(tekenaar, i) in filteredTekenaars" :key="i">{{ tekenaar.userProfile.voornaam }} {{ tekenaar.userProfile.achternaam }} {{ tekenaar.uid }}</div>
    <button @click="addTekenaarToOpdracht()" v-if="selectedUserForKoppeling_byId">Geef opdracht aan tekenaar</button>
  </div>
</template>

<script>
import store from "../../../store"
import { db } from "@/firebase"

export default {
  props: ["opdrachtId"],
  data() {
    return {
      selectedUserForKoppeling_byId: "",
      searchInput_tekenaarName: ""
    }
  },
  computed: {
    opdracht() {
      return store.getters.allOpdrachten.find(opdracht => opdracht.id == this.opdrachtId)
    },
    tekenaars() {
      return store.state.userAccounts
    },
    koppeling() {
      if (!this.selectedUserForKoppeling_byId) return
      const interestedUsers = this.opdracht.afhandeling?.interestedUsers || []
      const arrayOfIds = interestedUsers.map(e => e.userId) || []

      let userProfilesOfInterestedUsers = []
      if (arrayOfIds.length) {
        userProfilesOfInterestedUsers = [...this.tekenaars].filter(user => {
          return arrayOfIds.includes(user.uid)
        })
      } else {
        userProfilesOfInterestedUsers = []
      }

      const losers = userProfilesOfInterestedUsers.map(e => {
        return { userId: e.uid, userEmail: e.userProfile.email, voornaam: e.userProfile.voornaam || "" }
      })

      const winner = [...this.tekenaars].find(user => user.uid === this.selectedUserForKoppeling_byId)
      const winnerFormatted = { userId: winner.uid, userEmail: winner.userProfile.email, voornaam: winner.userProfile.voornaam || "" }

      if (JSON.stringify(losers).includes(winnerFormatted.userId)) {
        const indexOfWinner = losers.findIndex(item => item.userId === winnerFormatted.userId)
        losers.splice(indexOfWinner, 1)
      }
      return {
        winner: winnerFormatted,
        losers: losers
      }
    },
    filteredTekenaars() {
      const tekenaars = [...this.tekenaars]
      if (this.searchInput_tekenaarName === "") return []
      return tekenaars.filter(tekenaar => {
        if (!tekenaar.userProfile) return
        const name = {
          firstName: tekenaar.userProfile.voornaam ?? "",
          lastName: tekenaar.userProfile.achternaam ?? ""
        }
        const fullName = `${name.firstName.toLowerCase() || ""} ${name.lastName.toLowerCase() || ""}`
        return fullName.includes(this.searchInput_tekenaarName.toLowerCase())
      })
    }
  },
  methods: {
    setSelectedUserForKoppeling_byId(e) {
      if (this.selectedUserForKoppeling_byId === e) return (this.selectedUserForKoppeling_byId = "")
      this.selectedUserForKoppeling_byId = e
    },
    addTekenaarToOpdracht() {
      db.doc(`opdrachten/${this.opdrachtId}`).update({
        tekenaar: this.selectedUserForKoppeling_byId,
        status: "Uitgezet"
      })
      db.collection(`koppelingen`).add(this.koppeling)
    }
  }
}
</script>

<style lang="sass" scoped>
.selected
  background-color: blue
  padding: 6px
  color: white
  display: inline-block
  cursor: crosshair
  border-radius: 4px
</style>
